module.exports = __webpack_public_path__ + "static/media/style-2.1b7345f8.svg";